import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	public cards: Array<object>;
	public correctAnswers: number = 0;

	public timeLeft: number = 50;
	private interval;

	constructor() {
		this.cards = [];
		this.loadquestionsCards();
	}

	ngOnInit() { }

	loadquestionsCards() {
		this.correctAnswers = 0;
		this.cards = [
			{
				"img": "assets/img/1.png",
				"question": "This movie name is Titanic?",
				"answer": true
			},
			{
				"img": "assets/img/2.png",
				"question": "Microsoft is the owner of Facebook?",
				"answer": false
			},
			{
				"img": "assets/img/3.png",
				"question": "Shin-Chan is a Japanese cartoon character?",
				"answer": true
			},
			{
				"img": "assets/img/4.png",
				"question": "Rugby is national sport of New Zealand?",
				"answer": true
			},
			{
				"img": "assets/img/5.png",
				"question": "The fruit in the picture is Kiwi?",
				"answer": true
			}
			,
			{
				"img": "assets/img/6.png",
				"question": "This is South African flag?",
				"answer": true
			}
			,
			{
				"img": "assets/img/7.png",
				"question": "Minions are real creatures?",
				"answer": false
			}
			,
			{
				"img": "assets/img/8.png",
				"question": "Italy is capital of Paris?",
				"answer": true
			}
			,
			{
				"img": "assets/img/9.png",
				"question": "Taj Mahal is based in India?",
				"answer": true
			}
			,
			{
				"img": "assets/img/10.png",
				"question": "Animal in the picture is Zebra?",
				"answer": true
			}
		]
		this.startTimer();
	};

	logChoice(e) {
		if (e && (e.choice === e.payload.answer)) {
			this.correctAnswers += 1;
		}
		if (this.cards && this.cards.length <= 1) {
			if (!this.correctAnswers) this.correctAnswers = 1;
			$('#buyroundsModel').modal('show');
			clearInterval(this.interval);
		}
	}

	startTimer() {
		this.timeLeft = 50;
		this.interval = setInterval(() => {
			if (this.timeLeft > 0) {
				this.timeLeft--;
			} else {
				//$('#buyroundsModel').modal('show');
				clearInterval(this.interval);
			}
		}, 1000)
	}

	getFormatedNumber(number: number) {
		return ("0" + number).slice(-2);
	}
}
